<script lang="typescript">
    import { createEventDispatcher } from "svelte"
    import { Datepicker } from "svelte-calendar"
    import Select from "svelte-select/src/Select.svelte"
    import {
        dateToDbString,
        getUser,
        projectCache,
        updatePlanEntry,
    } from "../api"
    import { calenderTheme, defaultUser } from "../config"
    import SymbolSelector from "./SymbolSelector.svelte"
    import UserSelector from "./UserSelector.svelte"
    import Fa from "svelte-fa/src/fa.svelte"
    import { faTrash } from "@fortawesome/free-solid-svg-icons"

    const detach = createEventDispatcher()

    let projectSelectError = false
    $: if (data.project_id) {
        projectSelectError = false
    }

    function submit() {
        if (!data.project_id) {
            projectSelectError = true
            return
        }

        delete data.user
        delete data.project
        delete data.created_at
        delete data.updated_at
        delete data.read_only
        delete data.color

        if (isApi2) {
            delete data.starts_on
            delete data.ends_on
        } else {
            delete data.sort
        }
        console.log("submit ", data)
        detach("submit", data)
    }

    export let data: PlanEntry = {
        title: "",
        comment: "",
        project_id: null,
        starts_on: null,
        ends_on: null,
        hours_per_day: 1,
    }

    let project: any

    let projectChoices = projectCache.map((p) => ({
        value: p.id,
        label: p.customer?.name + " // " + p.name,
        group: p.customer?.name,
    }))
    projectChoices.forEach((p) => {
        if (p.value == data.project_id) {
            project = p
        }
    })

    let isApi2 = typeof data.id == "number" ? 0 : 1

    $: if (!isApi2 && data.starts_on == null) {
        console.log("SSS", data.starts_on)
        data.starts_on = dateToDbString(new Date())
        data.ends_on = data.starts_on
    }

    $: data.project_id = project?.value

    /*
    let startDate: Date = data.starts_on && new Date(data.starts_on)
    let endDate: Date = data.ends_on && new Date(data.ends_on)
    $: if (startDate) {
        data.starts_on =
            startDate.getFullYear() +
            "-" +
            (startDate.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            startDate.getDate().toString().padStart(2, "0")
    } else {
        data.starts_on = null
    }
    $: if (endDate) {
        data.ends_on =
            endDate.getFullYear() +
            "-" +
            (endDate.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            endDate.getDate().toString().padStart(2, "0")
    } else {
        data.ends_on = null
    }

    $: if (startDate || endDate) {
        if (!endDate) endDate = startDate
        if (!startDate) startDate = endDate
        if (startDate > endDate) endDate = startDate
    }*/

    let oldStartsOn: Date
    let oldEndsOn: Date

    $: if (data.starts_on || data.ends_on) {
        if (data.ends_on == null) {
            data.ends_on = data.starts_on
        }
        if (data.starts_on == null) {
            data.starts_on = data.ends_on
        }
        if (data.starts_on > data.ends_on) {
            if (oldStartsOn && oldEndsOn) {
                const diff = oldEndsOn.getTime() - oldStartsOn.getTime()
                data.ends_on = dateToDbString(
                    new Date(new Date(data.starts_on).getTime() + diff)
                )
            } else {
                data.ends_on = data.starts_on
            }
        }

        oldStartsOn = data.starts_on?.match(/^[1-9]\d{3}-/)
            ? new Date(data.starts_on)
            : oldStartsOn
        oldEndsOn = data.ends_on?.match(/^[1-9]\d{3}-/)
            ? new Date(data.ends_on)
            : oldEndsOn
    }
</script>

<form on:submit|preventDefault="{submit}">
    <div class="icons_right">
        {#await getUser(data.user_id || defaultUser) then user}
            <UserSelector
                user="{user}"
                on:selected="{(e) => {
                    data.user_id = e.detail.id
                }}"
            />
            <SymbolSelector bind:symbolCode="{data.symbol}" />
        {/await}
    </div>
    <div class="layout layout-gap layout-wrap">
        <div class="layout layout-vertical layout-gap">
            <input placeholder="Titel" bind:value="{data.title}" required />
            <Select
                bind:value="{project}"
                placeholder="Projekt"
                noOptionsMessage="keine Ergebnisse"
                items="{projectChoices}"
                groupBy="{(item) => item.group}"
                inputStyles="{projectSelectError
                    ? 'background-color: #ff5555; color: #fff;'
                    : ''}"
            />
            <textarea bind:value="{data.comment}" placeholder="Kommentar (Markdown)"></textarea>
        </div>
        <div class="layout layout-vertical layout-gap">
            <div class="layout layout-gap align-items-center layout-nowrap">
                <div class="layout layout-gap align-items-center layout-nowrap">
                    <input type="radio" bind:group="{isApi2}" value="{1}" id="without-timeplan" />
                    <label for="without-timeplan">ohne Zeitplan</label>
                </div>
                <div>
                    <input type="number" placeholder="Prio" bind:value="{data.sort}"
                        on:click="{() => {
                            isApi2 = 1
                        }}"
                    />
                </div>
            </div>
            <div class="layout layout-gap align-items-center layout-nowrap">
                <input type="radio" bind:group="{isApi2}" value="{0}" id="set-date" />
                <label for="set-date">Datum festlegen</label>
            </div>
            <div class="layout layout-gap align-items-center layout-nowrap">
                <!--<Datepicker
                    bind:selected="{startDate}"
                    format="DD.MM.YYYY"
                    theme="{calenderTheme}"
                    startOfWeekIndex="{1}"
                />-->
                <input
                    type="date"
                    style="width: 170px;"
                    bind:value="{data.starts_on}"
                    pattern="\d{4}-\d{2}-\d{2}"
                    on:click="{() => {
                        isApi2 = 0
                    }}"
                />
                <span> bis </span>
                <input
                    type="date"
                    style="width: 170px;"
                    bind:value="{data.ends_on}"
                    pattern="\d{4}-\d{2}-\d{2}"
                    min="{data.starts_on}"
                    on:click="{() => {
                        isApi2 = 0
                    }}"
                />
                <!--
                <Datepicker
                    bind:selected="{endDate}"
                    format="DD.MM.YYYY"
                    theme="{calenderTheme}"
                    startOfWeekIndex="{1}"
                />
                -->
            </div>
            <div class="layout layout-gap align-items-center layout-nowrap">
                <input
                    class="hours_per_day"
                    type="number"
                    min="0"
                    max="8"
                    step="0.5"
                    bind:value="{data.hours_per_day}"
                    on:click="{() => {
                        isApi2 = 0
                    }}"
                /><span>h/Tag<span>
            </div>
        </div>
    </div>
    <div class="form_buttons">
        {#if data.id}
            <button
                type="button"
                style="margin-right: 20px; color: red;"
                on:click="{() => {
                    if (confirm('Wirklich?')) detach('delete', data)
                }}"
            >
                <Fa icon="{faTrash}" size="1.2em" />
            </button>
        {/if}
        <button
            type="button"
            on:click="{() => {
                detach('cancel')
            }}">abbrechen</button
        >
        <button type="submit">OK</button>
    </div>
</form>
